(function() { window.GUID_ef1eb361_6db9_4348_9750_19d07ca3e007 = { getGuid: function() { return "ef1eb361-6db9-4348-9750-19d07ca3e007"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let BaseGameTypeId;
        (function (BaseGameTypeId) {
            BaseGameTypeId[BaseGameTypeId["General"] = 0] = "General";
            BaseGameTypeId[BaseGameTypeId["ScotchDouble"] = 3] = "ScotchDouble";
            BaseGameTypeId[BaseGameTypeId["ThreeHundredAndFirst"] = 4] = "ThreeHundredAndFirst";
            BaseGameTypeId[BaseGameTypeId["Cricket"] = 6] = "Cricket";
            BaseGameTypeId[BaseGameTypeId["Foosball"] = 9] = "Foosball";
            BaseGameTypeId[BaseGameTypeId["NONE"] = 10] = "NONE";
            BaseGameTypeId[BaseGameTypeId["Bocce"] = 11] = "Bocce";
            BaseGameTypeId[BaseGameTypeId["EightBall"] = 100] = "EightBall";
            BaseGameTypeId[BaseGameTypeId["NineBall"] = 101] = "NineBall";
            BaseGameTypeId[BaseGameTypeId["TenBall"] = 102] = "TenBall";
            BaseGameTypeId[BaseGameTypeId["Snooker"] = 103] = "Snooker";
        })(BaseGameTypeId = Enumeration.BaseGameTypeId || (Enumeration.BaseGameTypeId = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=BaseGameTypeId.pre.js.map
